import { certificateDeath } from "./certificate/death";
import { certificateHealth } from "./certificate/health";
import { certificateVaccination } from "./certificate/vaccination";
import { declarationProcedureNoAuthorization } from "./declaration/procedureNoAuthorization";
import { termAdmissionConsent } from "./term/admissionConsent";
import { termBodyDonationConsent } from "./term/bodyDonationConsent";
import { termEndoscopyAuthorization } from "./term/endoscopyAuthorization";
import { termRemovalDeadBodyConsent } from "./term/removalDeadBodyConsent";
import { termEuthanasiaConsent } from "./term/euthanasiaConsent";
import { termExaminationConsent } from "./term/examinationConsent";
import { termSurgeryConsent } from "./term/surgeryConsent";
import { termAnestheticProceduresConsent } from "./term/AnestheticProceduresConsent";
import { termDischargeRisksResponsibility } from "./term/dischargeRisksResponsibility";
import { examinationRequest } from "./requests/examinationRequest";
import { customRequest } from "./general/customRequest";

export const requestTemplates = {
  custom: {
    custom: customRequest,
  },
  attestation: {
    death: certificateDeath,
    health: certificateHealth,
    vaccination: certificateVaccination,
  },
  declaration: {
    procedureNoAuthorization: declarationProcedureNoAuthorization,
  },
  request: {
    examination: examinationRequest,
  },
  term: {
    endoscopyAuthorization: termEndoscopyAuthorization,
    admissionConsent: termAdmissionConsent,
    euthanasiaConsent: termEuthanasiaConsent,
    bodyDonationConsent: termBodyDonationConsent,
    removalDeadBodyConsent: termRemovalDeadBodyConsent,
    examinationConsent: termExaminationConsent,
    surgeryConsent: termSurgeryConsent,
    anestheticProceduresConsent: termAnestheticProceduresConsent,
    dischargeRisksResponsibility: termDischargeRisksResponsibility,
  },


};
